/* ============================================================
   FORTUNAZA FARMS — LANDING PAGE JAVASCRIPT
   Source of truth: landing-page.html
   All IDs/classes prefixed fz- to avoid Dawn conflicts
   ============================================================ */

(function() {
  'use strict';

  /* --- Announcement dismiss --- */
  function fzDismissAnnouncement() {
    var el = document.getElementById('fz-announcement');
    if (!el) return;
    el.style.maxHeight = el.offsetHeight + 'px';
    requestAnimationFrame(function() {
      el.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
      el.style.maxHeight = '0';
      el.style.opacity = '0';
      el.style.overflow = 'hidden';
    });
    sessionStorage.setItem('fz-ann-dismissed', '1');
  }
  window.fzDismissAnnouncement = fzDismissAnnouncement;

  document.addEventListener('DOMContentLoaded', function() {
    if (sessionStorage.getItem('fz-ann-dismissed')) {
      var ann = document.getElementById('fz-announcement');
      if (ann) ann.style.display = 'none';
    }

    /* --- FAQ accordion --- */
    document.querySelectorAll('.fz-faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.fz-faq-item');
        var isOpen = item.classList.contains('fz-open');
        document.querySelectorAll('.fz-faq-item').forEach(function(i) {
          i.classList.remove('fz-open');
          i.querySelector('.fz-faq-q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('fz-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* --- Scroll reveal --- */
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('fz-visible');
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.fz-reveal').forEach(function(el) { revealObserver.observe(el); });

    /* --- Sticky cart bar --- */
    var stickyCart = document.getElementById('fz-sticky-cart');
    var hero = document.getElementById('fz-hero');
    if (stickyCart && hero) {
      var cartObserver = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting) {
          stickyCart.classList.add('fz-visible');
        } else {
          stickyCart.classList.remove('fz-visible');
        }
      }, { threshold: 0 });
      cartObserver.observe(hero);
    }

    /* --- Sticky product tabs --- */
    var stickyProducts = window.fzStickyProducts || [];
    var stickyName = document.getElementById('fz-sticky-prod-name');
    var stickyUnit = document.getElementById('fz-sticky-prod-unit');
    var stickyVariantInput = document.getElementById('fz-sticky-variant-id');
    document.querySelectorAll('.fz-sticky-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        document.querySelectorAll('.fz-sticky-tab').forEach(function(t) { t.classList.remove('fz-active'); });
        tab.classList.add('fz-active');
        var idx = parseInt(tab.dataset.idx || '0');
        var prod = stickyProducts[idx];
        if (prod) {
          if (stickyName) {
            stickyName.style.opacity = '0';
            setTimeout(function() {
              stickyName.textContent = prod.name;
              if (stickyUnit) stickyUnit.textContent = prod.unit;
              stickyName.style.opacity = '1';
            }, 150);
          }
          if (stickyVariantInput && prod.variantId) {
            stickyVariantInput.value = prod.variantId;
          }
        }
      });
    });

    /* --- fz-journey carousel (timed slide between scenes) --- */
    (function() {
      var section = document.getElementById('fz-journey');
      var track = document.getElementById('fz-journey-track');
      if (!section || !track) return;
      var scenes = track.querySelectorAll('.fz-journey-scene');
      var dots = section.querySelectorAll('.fz-journey-dot');
      if (scenes.length < 2) return;

      var seconds = parseInt(section.dataset.fzJourneyInterval, 10);
      if (isNaN(seconds) || seconds < 1) seconds = 6;
      var intervalMs = seconds * 1000;

      var palettes = [
        { bg:'#1A7A6E', border:'rgba(255,255,255,0.12)', text:'#F5FCF9', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
        { bg:'#EBF6F2', border:'#1A7A6E',                text:'#1A7A6E', ctaBg:'#1A7A6E', ctaText:'#EBF6F2' },
        { bg:'#115549', border:'rgba(255,255,255,0.12)', text:'#F5FCF9', ctaBg:'#EBF6F2', ctaText:'#1A7A6E' },
        { bg:'#FF5533', border:'rgba(26,122,110,0.3)',   text:'#1A7A6E', ctaBg:'#1A7A6E', ctaText:'#F5FCF9' }
      ];

      var idx = 0;
      var paused = false;
      section.addEventListener('mouseenter', function() { paused = true; });
      section.addEventListener('mouseleave', function() { paused = false; });

      function go(next) {
        idx = ((next % scenes.length) + scenes.length) % scenes.length;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        scenes.forEach(function(s, i) { s.classList.toggle('fz-active', i === idx); });
        dots.forEach(function(d, i) {
          d.classList.toggle('fz-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        if (palettes[idx] && typeof window.applyNavPalette === 'function') {
          var rect = section.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            window.applyNavPalette(palettes[idx]);
          }
        }
      }

      dots.forEach(function(d, i) {
        d.addEventListener('click', function() { go(i); });
      });

      setInterval(function() {
        if (paused || document.hidden) return;
        go(idx + 1);
      }, intervalMs);
    })();

    /* --- Nav color-changing scroll --- */
    var nav = document.getElementById('fz-nav');
    var sectionPalettes = {
      'fz-hero':         { bg:'#1A7A6E', border:'rgba(255,255,255,0.12)', text:'#F5FCF9', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-products':     { bg:'#F5FCF9', border:'#1A7A6E',                text:'#1A7A6E', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-journey':      { bg:'#1A7A6E', border:'rgba(255,255,255,0.12)', text:'#F5FCF9', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-story':        { bg:'#F5FCF9', border:'#1A7A6E',                text:'#1A7A6E', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-recipes':      { bg:'#EBF6F2', border:'#1A7A6E',                text:'#1A7A6E', ctaBg:'#1A7A6E', ctaText:'#EBF6F2' },
      'fz-benefits':     { bg:'#115549', border:'rgba(255,255,255,0.12)', text:'#F5FCF9', ctaBg:'#EBF6F2', ctaText:'#1A7A6E' },
      'fz-stores':       { bg:'#F5FCF9', border:'#1A7A6E',                text:'#1A7A6E', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-testimonials': { bg:'#1A7A6E', border:'rgba(255,255,255,0.12)', text:'#F5FCF9', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-compare':      { bg:'#EBF6F2', border:'#1A7A6E',                text:'#1A7A6E', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-bundle':       { bg:'#F5FCF9', border:'#1A7A6E',                text:'#1A7A6E', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-faq':          { bg:'#F5FCF9', border:'#1A7A6E',                text:'#1A7A6E', ctaBg:'#FF5533', ctaText:'#F5FCF9' },
      'fz-newsletter':   { bg:'#FF5533', border:'rgba(26,122,110,0.3)',   text:'#1A7A6E', ctaBg:'#1A7A6E', ctaText:'#F5FCF9' }
    };

    function applyNavPalette(p) {
      if (!p || !nav) return;
      nav.style.backgroundColor  = p.bg;
      nav.style.borderBottomColor = p.border;
      nav.querySelectorAll('.fz-nav-links a, .fz-nav-logo').forEach(function(el) { el.style.color = p.text; });
      var cta = nav.querySelector('.fz-nav-cta');
      if (cta) { cta.style.background = p.ctaBg; cta.style.color = p.ctaText; }
    }
    window.applyNavPalette = applyNavPalette;

    var insideJourney = false;
    var sectionObserver = new IntersectionObserver(function(entries) {
      var best = null, bestRatio = 0;
      entries.forEach(function(e) {
        if (e.intersectionRatio > bestRatio) { bestRatio = e.intersectionRatio; best = e; }
      });
      if (!best) return;
      var id = best.target.id;
      if (id === 'fz-journey') { insideJourney = best.isIntersecting; return; }
      if (!insideJourney && best.isIntersecting && sectionPalettes[id]) {
        applyNavPalette(sectionPalettes[id]);
      }
    }, { threshold: [0.15, 0.4, 0.65] });
    document.querySelectorAll('section[id^="fz-"]').forEach(function(s) { sectionObserver.observe(s); });
    applyNavPalette(sectionPalettes['fz-hero'] || sectionPalettes[Object.keys(sectionPalettes)[0]]);

    /* --- WebGL Shaders --- */
    (function() {
      var SHADERS = [
        {
          id: 'fz-hero-shader',
          fs: [
            'precision mediump float;',
            'uniform float uTime;',
            'uniform vec2 uRes;',
            'float h21(vec2 p){p=fract(p*vec2(234.34,435.345));p+=dot(p,p+34.23);return fract(p.x*p.y);}',
            'float vn(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
            '  return mix(mix(h21(i),h21(i+vec2(1,0)),f.x),mix(h21(i+vec2(0,1)),h21(i+vec2(1,1)),f.x),f.y);}',
            'float fbm(vec2 p){float v=0.,a=.5;mat2 r=mat2(1.6,1.2,-1.2,1.6);',
            '  for(int i=0;i<6;i++){v+=a*vn(p);p=r*p;a*=.5;}return v;}',
            'void main(){',
            '  vec2 uv=gl_FragCoord.xy/uRes;',
            '  float t=uTime*.042;',
            '  vec2 q=vec2(fbm(uv*2.8+t*vec2(.38,.14)),fbm(uv*2.8+vec2(5.2,1.3)+t*vec2(-.28,.19)));',
            '  float f=fbm(uv*2.8+1.9*q+t*vec2(.09,.04));',
            '  f=smoothstep(0.,1.,f*.5+.5);',
            '  vec3 dark=vec3(.078,.169,.129);',
            '  vec3 mid=vec3(.118,.243,.188);',
            '  vec3 lite=vec3(.22,.47,.36);',
            '  vec3 gold=vec3(1.,.816,.0);',
            '  vec3 col=dark;',
            '  col=mix(col,mid,smoothstep(.18,.54,f));',
            '  col=mix(col,lite,smoothstep(.50,.78,f)*.4);',
            '  col=mix(col,gold,smoothstep(.82,.97,f)*.13);',
            '  gl_FragColor=vec4(col,1.);',
            '}'
          ].join('\n')
        },
        {
          id: 'fz-benefits-shader',
          fs: [
            'precision mediump float;',
            'uniform float uTime;',
            'uniform vec2 uRes;',
            'float h21(vec2 p){p=fract(p*vec2(127.1,311.7));p+=dot(p,p+37.11);return fract(p.x*p.y);}',
            'float vn(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
            '  return mix(mix(h21(i),h21(i+vec2(1,0)),f.x),mix(h21(i+vec2(0,1)),h21(i+vec2(1,1)),f.x),f.y);}',
            'float fbm(vec2 p){float v=0.,a=.5;mat2 r=mat2(1.4,1.0,-1.0,1.4);',
            '  for(int i=0;i<5;i++){v+=a*vn(p);p=r*p;a*=.55;}return v;}',
            'void main(){',
            '  vec2 uv=gl_FragCoord.xy/uRes;',
            '  float t=uTime*.028;',
            '  vec2 q=vec2(fbm(uv*2.2+t*vec2(.22,.08)),fbm(uv*2.2+vec2(3.7,2.1)+t*vec2(-.18,.12)));',
            '  float f=fbm(uv*2.2+2.2*q+t*vec2(.06,.03));',
            '  f=smoothstep(0.,1.,f*.5+.5);',
            '  vec3 deep=vec3(.055,.120,.090);',
            '  vec3 base=vec3(.078,.169,.129);',
            '  vec3 ember=vec3(1.,.333,.2);',
            '  vec3 gold=vec3(1.,.816,.0);',
            '  vec3 col=deep;',
            '  col=mix(col,base,smoothstep(.15,.50,f));',
            '  col=mix(col,ember,smoothstep(.72,.90,f)*.08);',
            '  col=mix(col,gold,smoothstep(.85,.98,f)*.06);',
            '  gl_FragColor=vec4(col,1.);',
            '}'
          ].join('\n')
        }
      ];

      var VS = 'attribute vec2 a_pos; void main(){gl_Position=vec4(a_pos,0.,1.);}';
      var QUAD = new Float32Array([-1,-1, 1,-1, -1,1, 1,1]);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function initShader(cfg) {
        var canvas = document.getElementById(cfg.id);
        if (!canvas) return;
        var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (!gl) return;

        function resize() {
          var r = canvas.getBoundingClientRect();
          canvas.width  = Math.round(r.width  * 0.5);
          canvas.height = Math.round(r.height * 0.5);
          canvas.style.width  = r.width  + 'px';
          canvas.style.height = r.height + 'px';
          gl.viewport(0, 0, canvas.width, canvas.height);
        }

        function mkShader(type, src) {
          var s = gl.createShader(type);
          gl.shaderSource(s, src);
          gl.compileShader(s);
          if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
            console.warn(cfg.id + ' shader error:', gl.getShaderInfoLog(s));
            return null;
          }
          return s;
        }

        var vs = mkShader(gl.VERTEX_SHADER, VS);
        var fs = mkShader(gl.FRAGMENT_SHADER, cfg.fs);
        if (!vs || !fs) return;

        var prog = gl.createProgram();
        gl.attachShader(prog, vs); gl.attachShader(prog, fs);
        gl.linkProgram(prog);
        if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { return; }

        var buf = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buf);
        gl.bufferData(gl.ARRAY_BUFFER, QUAD, gl.STATIC_DRAW);
        var posLoc  = gl.getAttribLocation(prog, 'a_pos');
        var timeLoc = gl.getUniformLocation(prog, 'uTime');
        var resLoc  = gl.getUniformLocation(prog, 'uRes');
        gl.enableVertexAttribArray(posLoc);
        gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

        var raf = null, t0 = null;

        function draw(ts) {
          if (!t0) t0 = ts;
          gl.useProgram(prog);
          gl.uniform1f(timeLoc, (ts - t0) * 0.001);
          gl.uniform2f(resLoc, canvas.width, canvas.height);
          gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
          if (!reducedMotion) raf = requestAnimationFrame(draw);
        }

        var io = new IntersectionObserver(function(entries) {
          if (entries[0].isIntersecting) {
            if (!raf) raf = requestAnimationFrame(draw);
          } else {
            if (raf) { cancelAnimationFrame(raf); raf = null; }
          }
        }, { threshold: 0.01 });
        io.observe(canvas);

        window.addEventListener('resize', resize, { passive: true });
        resize();

        if (reducedMotion) {
          gl.useProgram(prog);
          gl.uniform1f(timeLoc, 3.0);
          gl.uniform2f(resLoc, canvas.width, canvas.height);
          gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        }
      }

      SHADERS.forEach(initShader);
    })();

    /* --- Number count animation --- */
    (function() {
      function parseTarget(el) {
        var text = el.textContent.trim();
        var m = text.match(/^([\d,]+)(.*)$/);
        if (!m) return null;
        return { value: parseInt(m[1].replace(/,/g, '')), suffix: m[2], useComma: m[1].indexOf(',') !== -1 };
      }
      function countUp(el, parsed) {
        var duration = 1600, start = performance.now();
        function step(now) {
          var p = Math.min((now - start) / duration, 1);
          var ease = 1 - Math.pow(1 - p, 3);
          var val = Math.round(parsed.value * ease);
          el.textContent = (parsed.useComma ? val.toLocaleString() : val) + parsed.suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      var els = Array.from(document.querySelectorAll('.fz-hero-strip-item strong'))
                     .concat(Array.from(document.querySelectorAll('.fz-story-stat-num')));
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (!e.isIntersecting) return;
          var parsed = parseTarget(e.target);
          if (!parsed) return;
          io.unobserve(e.target);
          countUp(e.target, parsed);
        });
      }, { threshold: 0.6 });
      els.forEach(function(el) { io.observe(el); });
    })();

    /* --- Custom cursor --- */
    (function() {
      if (!window.matchMedia('(pointer: fine)').matches) return;
      var cursor = document.getElementById('fz-cursor');
      var ring = document.getElementById('fz-cursor-ring');
      if (!cursor || !ring) return;
      var mx = -200, my = -200, rx = -200, ry = -200;
      document.addEventListener('mousemove', function(e) { mx = e.clientX; my = e.clientY; cursor.style.opacity = '1'; });
      document.addEventListener('mouseleave', function() { cursor.style.opacity = '0'; });
      var interactiveSelectors = 'a, button, [role="button"], .fz-faq-q, .fz-recipe-card, .fz-journey-dot, .fz-sticky-tab';
      document.querySelectorAll(interactiveSelectors).forEach(function(el) {
        el.addEventListener('mouseenter', function() { document.body.classList.add('fz-cursor-hover'); });
        el.addEventListener('mouseleave', function() { document.body.classList.remove('fz-cursor-hover'); });
      });
      function animCursor() {
        rx += (mx - rx) * 0.14;
        ry += (my - ry) * 0.14;
        cursor.style.left = rx + 'px';
        cursor.style.top  = ry + 'px';
        requestAnimationFrame(animCursor);
      }
      animCursor();
    })();

    /* --- Scroll progress bar --- */
    var scrollBar = document.getElementById('fz-scroll-progress');
    if (scrollBar) {
      window.addEventListener('scroll', function() {
        var scrolled = window.scrollY;
        var total = document.documentElement.scrollHeight - window.innerHeight;
        scrollBar.style.width = (total > 0 ? (scrolled / total) * 100 : 0) + '%';
      }, { passive: true });
    }

    /* --- Smooth anchor scroll --- */
    document.querySelectorAll('a[href^="#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var navH = (document.getElementById('fz-nav') || document.querySelector('#nav') || { offsetHeight: 64 }).offsetHeight;
        var start = window.scrollY;
        var end = target.getBoundingClientRect().top + window.scrollY - navH;
        var startTime = null;
        var duration = 860;
        function ease(t) { return t < 0.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1; }
        function step(ts) {
          if (!startTime) startTime = ts;
          var p = Math.min((ts - startTime) / duration, 1);
          window.scrollTo(0, start + (end - start) * ease(p));
          if (p < 1) requestAnimationFrame(step);
          else history.pushState(null, '', a.getAttribute('href'));
        }
        requestAnimationFrame(step);
      });
    });

    /* --- Bundle subscribe toggle --- */
    window.fzSetBundleMode = function(bundleId, mode, btn) {
      var prices = { all: { once: '$34.99', sub: '$29.74' }, pc: { once: '$21.99', sub: '$18.69' } };
      var ctaTexts = { once: 'Add to Cart', sub: 'Subscribe & Save' };
      // Toggle buttons in same bundle
      btn.closest('.fz-bundle-info').querySelectorAll('.fz-bundle-toggle-btn').forEach(function(b) {
        b.classList.toggle('fz-active', b === btn);
      });
      // Price
      var priceEl = document.getElementById('fz-bundle-' + bundleId + '-price');
      if (priceEl && prices[bundleId]) {
        priceEl.style.opacity = '0';
        setTimeout(function() {
          priceEl.textContent = prices[bundleId][mode];
          priceEl.style.opacity = '1';
        }, 120);
      }
      // Freq row
      var freqRow = document.getElementById('fz-bundle-freq-row-' + bundleId);
      if (freqRow) freqRow.classList.toggle('fz-visible', mode === 'sub');
      // CTA text
      var ctaEl = document.getElementById('fz-bundle-' + bundleId + '-cta');
      if (ctaEl && prices[bundleId]) {
        ctaEl.textContent = ctaTexts[mode] + ' — ' + prices[bundleId][mode];
      }
    };

    /* --- Newsletter submit --- */
    var nlForm = document.querySelector('.fz-newsletter-form');
    if (nlForm) {
      nlForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = nlForm.querySelector('button');
        if (btn) { btn.textContent = "You're in!"; btn.disabled = true; }
      });
    }

    /* --- Recipe card 3D tilt --- */
    document.querySelectorAll('.fz-recipe-card').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width  - 0.5;
        var y = (e.clientY - r.top)  / r.height - 0.5;
        card.style.transform = 'perspective(600px) rotateX(' + (-y * 10) + 'deg) rotateY(' + (x * 10) + 'deg)';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transform = '';
      });
    });

    /* --- Parallax hero fruit circle (if present) --- */
    var heroCircle = document.querySelector('.fz-hero-fruit-circle');
    if (heroCircle) {
      window.addEventListener('scroll', function() {
        var progress = window.scrollY / (window.innerHeight || 1);
        heroCircle.style.transform = 'translateY(' + (progress * 38) + 'px)';
      }, { passive: true });
    }

    /* --- Leaflet map init (called by stores section) --- */
    window.fzInitMap = function(stores) {
      if (typeof L === 'undefined') return;
      var mapEl = document.getElementById('fz-leaflet-map');
      if (!mapEl) return;
      var map = L.map('fz-leaflet-map').setView([30.0, -80.0], 4);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 19
      }).addTo(map);
      var icon = L.divIcon({
        html: '<div style="width:14px;height:14px;background:#FF5533;border-radius:50%;border:2px solid #1A7A6E;"></div>',
        iconSize: [14,14], iconAnchor: [7,7], className: ''
      });
      stores.forEach(function(s) {
        L.marker([s.lat, s.lng], { icon: icon }).addTo(map)
          .bindPopup('<div class="fz-map-popup-name">' + s.name + '</div><div class="fz-map-popup-city">' + s.city + '</div>');
      });
    };

    /* --- Active nav link --- */
    var navLinks = document.querySelectorAll('.fz-nav-links a[href^="#"]');
    if (navLinks.length) {
      var activeObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            navLinks.forEach(function(a) {
              a.classList.toggle('fz-nav-active', a.getAttribute('href') === '#' + e.target.id);
            });
          }
        });
      }, { threshold: 0.35 });
      document.querySelectorAll('section[id]').forEach(function(s) { activeObserver.observe(s); });
    }

  }); // end DOMContentLoaded

})();
